import { Environment } from './interfaces';
var isProd = function isProd(environment) {
  return [Environment.PRODUCTION.toString(), Environment.STAGING.toString()].includes(environment.toLowerCase());
};
var getEnvironmentByCheggBaseUrl = function getEnvironmentByCheggBaseUrl(url) {
  url = url.replace(/\.com.*/, '.com/');
  return url.match(/^http[s]?:\/\/[a-zA-Z0-9.-]*chegg.com((:[0-9]+)?\/?)?$/) ? Environment.PRODUCTION : Environment.TEST;
};
export { isProd, getEnvironmentByCheggBaseUrl };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/common/helper.js
// module id = 641
// module chunks = 11